module.exports = __webpack_public_path__ + "01_veryshort_gold.d5ee9ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_veryshort_gold.png
// module id = Wo5R
// module chunks = 0